export default __webpack_public_path__ + "static/media/ic-analytics-active.883b35a1.svg";